

/***
 * 库存和配送信息查询
 */
const stockpileQuery = {
  // 配置信息
  config: {
    apiUrl: 'https://www.shudachen.com:18088/open/api/userActivity/listShippedInfo',
    site: 'com',
    defaultIp: ''
  },

  // 配送信息模板
  shippingMessages: {
    US: {
      US: 'Shipped from a local US warehouse, delivered within 2-7 days.',
      // CA: 'Shipped from a local US warehouse, delivered within 7-10 days.',
    },
    DE: {
      EU: 'Shipped from a local DE warehouse, delivered within 2-7 days.'
    }
  },

  // 初始化并执行查询
  async init() {
    try {
      const quantityDom = document.querySelector('#erp-stockpile-quantity');
      if (!quantityDom) return;

      const quantityText = quantityDom.querySelector('span');
      if (!quantityText) return;

      const productId = quantityDom.dataset.productId;
      const sku = quantityDom.dataset.productSku;

      const shippingInfo = await this.fetchShippingInfo(productId, sku);
      if (shippingInfo && shippingInfo.sellableQty > 0) {
        quantityDom.style.display = 'block';
        this.updateShippingMessage(quantityText, shippingInfo);
      }
    } catch (error) {
      console.error('Failed to initialize stock query:', error);
    }
  },

  // 获取配送信息
  async fetchShippingInfo(productId, sku) {
    try {
      const response = await fetch(this.config.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          site: this.config.site,
          platformProductId: productId,
          platformSku: sku,
          ipAddr: this.config.defaultIp
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const { data } = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching shipping info:', error);
      return null;
    }
  },

  // 更新配送信息显示
  updateShippingMessage(element, { country, fromCountry }) {
    try {
      let message = '';

      if (fromCountry.toLowerCase() === 'de') {
        message = this.shippingMessages.DE.EU;
      } else {
        message = this.shippingMessages[fromCountry]?.[country];
      }
      if (message) {
        element.textContent = message;
        element.classList.add('erp-stockpile-span');
      }
    } catch (error) {
      console.error('Error updating shipping message:', error);
    }
  }
};
// 执行初始化
stockpileQuery.init();


function discountCopyCode(event) {
  event.preventDefault()
  let discountCodeElement = document.querySelector('.product-sale-discount-salecontent .code .code-value');
  let copyElement = document.querySelector('.product-sale-discount-salecontent .code .code-copy');
  if (discountCodeElement) {
    let discountCode = discountCodeElement.innerText;
    let tempTextarea = document.createElement('textarea');
    tempTextarea.value = discountCode;
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    tempTextarea.setSelectionRange(0, 99999); // 对于移动设备
    document.execCommand('copy');
    // 移除临时的textarea元素
    document.body.removeChild(tempTextarea);
    copyElement.textContent = 'Copied'
  }
}


function gotoNewVip(event) {
  event.preventDefault()
  window.open('https://www.ulanzi.com/pages/new-vip', '_blank');
}


//修改afterpay样式
function getCurrentDevice() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
// 样式修改函数
function modifyAfterpayStyles() {
  const afterpayDom = document.querySelector('afterpay-placement');
  if (!afterpayDom || !afterpayDom.shadowRoot || !getCurrentDevice()) {
    console.log('No shadow root found in <afterpay-placement> or not a mobile device');
    return;
  }
  afterpayDom.style.margin = "0"
  const afterpayContainer = afterpayDom.shadowRoot.querySelector('.afterpay-paragraph');
  if (afterpayContainer) {
    afterpayContainer.style.fontSize = 'var(--messaging-font-size, 12px)';
    const afterpayButton = afterpayContainer.querySelector('.afterpay-logo');
    const afterpaySvg = afterpayContainer.querySelector('.afterpay-logo.type-badge svg');
    if (afterpayButton && afterpaySvg) {
      afterpayButton.style.width = 'var(--logo-badge-width, 70px)';
      afterpaySvg.style.height = 'calc(25 / 104 * var(--logo-badge-width, 104px))';
      afterpaySvg.style.width = 'var(--logo-badge-width, 70px)';
      console.log('Found and modified afterpayButton and afterpaySvg');
    }
  } else {
    console.log('Could not find .afterpay-paragraph inside shadow DOM');
  }
}
// 调用样式修改函数
// modifyAfterpayStyles();